var i = Object.defineProperty;
var o = (p, r) => i(p, "name", { value: r, configurable: !0 });

// src/viewport/preview.ts
import { definePreviewAddon as s } from "storybook/internal/csf";

// src/viewport/constants.ts
var t = "storybook/viewport", e = "viewport", a = `${t}/panel`, d = `${t}/tool`;

// src/viewport/preview.ts
var l = {
  [e]: { value: void 0, isRotated: !1 }
}, A = /* @__PURE__ */ o(() => s({
  initialGlobals: l
}), "default");
export {
  A as default,
  l as initialGlobals
};
